import { Button, HStack } from '@chakra-ui/react';
import { Label } from '@/components/atoms/Label';
import { totalPages } from '../utils/listPagination';

interface ListPaginationProps {
  page: number;
  count: number;
  perPage: number;
  hasPrevious: boolean;
  hasNext: boolean;
  isLoading?: boolean;
  onPrevious: () => void;
  onNext: () => void;
  singular: string;
  plural: string;
  color?: string;
}

export function ListPagination({
  page,
  count,
  perPage,
  hasPrevious,
  hasNext,
  isLoading = false,
  onPrevious,
  onNext,
  singular,
  plural,
  color,
}: ListPaginationProps) {
  if (count <= 0) return null;

  const pages = totalPages(count, perPage);
  const itemLabel = count === 1 ? singular : plural;

  return (
    <HStack width="100%" justify="space-between" spacing={3} flexWrap="wrap">
      <Button
        size="sm"
        variant="outline"
        borderColor={color}
        color={color}
        onClick={onPrevious}
        isDisabled={!hasPrevious || isLoading}
      >
        Anterior
      </Button>
      <Label fontSize="sm" textAlign="center" color="gray.600">
        Página {page} de {pages} · {count} {itemLabel}
      </Label>
      <Button
        size="sm"
        variant="outline"
        borderColor={color}
        color={color}
        onClick={onNext}
        isDisabled={!hasNext || isLoading}
      >
        Próxima
      </Button>
    </HStack>
  );
}
